(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["moment", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["antd"] = factory(require("moment"), require("react"), require("react-dom"));
	else
		root["antd"] = factory(root["moment"], root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_moment__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 